import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { watsappURL } from '../../../../../env-config';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

@Component({
  selector: 'app-task-worker-whapp-sel',
  templateUrl: './task-worker-whapp-sel.component.html',
  styleUrls: ['./task-worker-whapp-sel.component.css']
})
export class TaskWorkerWhappSelComponent implements OnInit {
  dialog: MatDialogRef<any>;
  loading: boolean = false;
  workers: IWorker[] = [];

  constructor(
    public dialogRef: MatDialogRef<any>,
    private _dialogService: DialogService,
    private _viewContainerRef: ViewContainerRef,
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() { }

  openWorkerWhatsapp(worker: IWorker) {
    const phones = _.get(worker, 'phones', [])
    phones.forEach((phone: any) => {
      window.open(watsappURL({ text: '', phone: phone.number }))
    });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }
}